export interface CancellableDelayParams {
	signal?: AbortSignal;
	delay?: number;
}

export const cancellableDelay = ({ delay = 200, signal }: CancellableDelayParams = {}) => {
	return new Promise<void>((resolve, reject) => {
		const timeout = setTimeout(() => {
			resolve();
		}, delay);

		signal?.addEventListener('abort', () => {
			clearTimeout(timeout);
			reject();
		});
	});
};
